import { Dispatch, SetStateAction } from "react";
// import { useLocation } from "react-router-dom";

import { User } from "../../Utils/Types";
import { Toaster } from "../../Components/ui/toast";
import Calendar from "../../Components/Calendar/Calendar";
// import MyCalendar2 from "../../Components/Calendar/Calendar2";

const Home = ({
	authenticatedUser,
	setAuthenticatedUser,
	setUserIsAuthenticated,
}: {
	authenticatedUser: User | null;
	setAuthenticatedUser: Dispatch<SetStateAction<User | null>>;
	setUserIsAuthenticated: Dispatch<SetStateAction<boolean>>;
}) => {
	// const location = useLocation();
	// const isVariation2 = location.pathname.includes("/variation2");
	return (
		<>
			<div className='w-full h-full relative overflow-hidden'>
				{/* {isVariation2 ? (
					<MyCalendar2
						setAuthenticatedUser={setAuthenticatedUser}
						setUserIsAuthenticated={setUserIsAuthenticated}
					/>
				) : ( */}
				<Calendar
					authenticatedUser={authenticatedUser}
					setAuthenticatedUser={setAuthenticatedUser}
					setUserIsAuthenticated={setUserIsAuthenticated}
				/>
				{/* )} */}
			</div>
			<Toaster />
		</>
	);
};

export default Home;
